import { useRef, useState } from 'react';
import { Popover, ArrowContainer } from 'react-tiny-popover'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { useTranslation } from 'react-i18next';
import { faGlobe } from '@fortawesome/free-solid-svg-icons'

export default function Pop(props) {
    const [isPopoverOpen, setIsPopoverOpen] = useState(false)
    const clickMeButtonRef = useRef();
    const { i18n, t } = useTranslation(['booking']);

    const languages = [
        {
            i18nLanguage: 'en',
            display: 'English'
        },
        {
            i18nLanguage: 'tc',
            display: '繁體中文'
        },
        {
            i18nLanguage: 'sc',
            display: '简体中文'
        }
    ]

    const lang = (lng) => {
        i18n.changeLanguage(lng);
    };


    return <Popover
        isOpen={isPopoverOpen}
        positions={['bottom']}
        padding={4}
        onClickOutside={() => setIsPopoverOpen(false)}
        ref={clickMeButtonRef} // if you'd like a ref to your popover's child, you can grab one here
        content={({ position, childRect, popoverRect }) => (
            <ArrowContainer // if you'd like an arrow, you can import the ArrowContainer!
                position={position}
                childRect={childRect}
                popoverRect={popoverRect}
                arrowColor={'#2a67b4'}
                arrowSize={10}
                className='mt-2.5 bg-wsd header-container-p0 rounded-2xl'
                arrowClassName='header-arrow'
            >
                <div
                    className="py-4 w-[180px] mt-1 flex flex-col text-left"
                    onClick={() => setIsPopoverOpen(!isPopoverOpen)}
                >
                    {languages.map((language, idx) => {
                        return <div onClick={() => lang(language.i18nLanguage)} key={idx} className={`${language.i18nLanguage === i18n.language? 'bg-sky-300 text-wsd': '' } transition font-medium duration-300 ease-in-out hover:bg-sky-300 hover:text-wsd hover:cursor-pointer w-full text-left text-white text-xl p-4 border-gray-50/40 border-b-[0.5px]`}>{language.display}</div>
                    })}
                </div>
            </ArrowContainer>
        )}
    >
        <div className="cursor-pointer flex flex-none items-center" onClick={() => setIsPopoverOpen(!isPopoverOpen)}>
            <div className={`${!!isPopoverOpen ? 'border-[1px] border-wsd bg-white text-wsd' : 'border-[1px] border-wsd bg-wsd text-white'} px-[8px] py-1 border-1 rounded-full font-meidum`}>
                <FontAwesomeIcon icon={faGlobe} alt="Open Up The Language Selector Popover" />
            </div>
        </div>
    </Popover>
}